module.exports = __webpack_public_path__ + "static/uveryPerson.95637d0a.png";